/**
 * Spanish locale strings. Mirrors the shape of en.ts.
 */
import type { LocaleStrings } from "./en";

export const es: LocaleStrings = {
  home: {
    tagline: "Vida sin prisa, encanto sureño y estilo bohemio: moda seleccionada para el alma de espíritu libre.",
    footerTagline: "Vida sin prisa, encanto sureño y estilo bohemio. Moda seleccionada para el alma de espíritu libre.",
  },
  promoTicker: {
    closeLabel: "Cerrar promociones",
    messages: [
      "✨ Envío gratis en pedidos de $150 o más ✨",
      "🌿 Nuevos estilos boho cada día — Descubre lo último",
      "💛 Únete a la Boho Fam — Acceso anticipado a los nuevos lanzamientos",
      "🌹 Moda bohemia seleccionada — Tops, vestidos, joyería y más",
    ],
  },
  shopByCollection: {
    heading: "Compra por Colección",
    tagline: "Seis estéticas boho seleccionadas: encuentra la que te represente.",
  },
  categoryCard: {
    shopNow: "Comprar ahora",
    productOne: "producto",
    productOther: "productos",
  },
  shopByCategory: {
    heading: "Compra por Categoría",
    tagline: "Encuentra tu look boho perfecto",
    shopNow: "Comprar ahora",
    loading: "Cargando…",
    stylesSuffix: "estilos",
    plusSizeSuffix: "estilos talla grande",
    tiles: {
      tops: "Tops",
      bottoms: "Pantalones",
      goddess: "Goddess",
      dresses: "Vestidos",
      footwear: "Calzado",
      jewelry: "Joyería",
      "lifestyle-decor": "Lifestyle y Decoración",
    },
  },
  megaMenu: {
    trigger: "Colecciones",
    ariaLabel: "Menú de colecciones",
    viewAll: "Ver todo →",
    viewAllCollections: "Ver todas las colecciones",
    apparelHeading: "Ropa",
    plusLabel: "Tallas grandes",
    taxonomy: {
      apparel: "Ropa",
      goddess: "Goddess",
      lifestyle: "Lifestyle",
      sandals: "Sandalias",
      boots: "Botas",
      heels: "Tacones",
      jewelry: "Joyería",
      accessories: "Accesorios",
      bags: "Bolsos",
      dresses: "Vestidos",
      "one-pieces": "Enterizos",
      loungewear: "Ropa de Descanso",
      footwear: "Calzado",
      "lifestyle-decor": "Lifestyle y Decoración",
      tops: "Tops",
      bottoms: "Pantalones",
      "outfit-sets": "Conjuntos",
      necklaces: "Collares",
      earrings: "Aretes",
      bracelets: "Pulseras",
      rings: "Anillos",
      "bag-charms": "Dijes para Bolso",
      belts: "Cinturones",
      hats: "Sombreros",
      "hair-accessories": "Accesorios para el Cabello",
      sunglasses: "Gafas de Sol",
      "crossbody-bags": "Bolsos Cruzados",
      handbags: "Bolsos de Mano",
      "shoulder-bags": "Bolsos de Hombro",
      "tote-bags": "Bolsos Tote",
      "weekender-bags": "Bolsos de Fin de Semana",
      "maxi-dresses": "Vestidos Largos",
      "midi-dresses": "Vestidos Midi",
      "mini-dresses": "Vestidos Cortos",
      jumpsuits: "Monos",
      overalls: "Petos",
      rompers: "Pelele",
      "lounge-set": "Conjunto de Descanso",
      pajamas: "Pijamas",
      "pajamas-set": "Conjunto de Pijama",
      "hot-chocolate-design": "Hot Chocolate Design",
      "colorstep-fashion": "Colorstep Fashion co.Ltd",
      "area-rugs": "Alfombras",
      "accent-furniture": "Muebles de Acento",
      "bedding-sets": "Juegos de Cama",
      "table-decor": "Decoración de Mesa",
      "wall-mirrors": "Espejos de Pared",
      "throw-blankets": "Mantas Decorativas",
      "wall-hangings": "Tapices de Pared",
    },
  },
  bohoCollections: {
    "boho-western": {
      title: "Boho: Western",
      tagline: "Flecos, ante y espíritu turquesa",
      metaDescription:
        "Flecos, ante, turquesa y espíritu de la pradera: estilo boho con toque western.",
    },
    "boho-cottagecore": {
      title: "Boho: Cottagecore",
      tagline: "Flores, broderie y romance campestre",
      metaDescription:
        "Flores, broderie y romance de pradera: piezas boho cottagecore.",
    },
    "boho-coastal": {
      title: "Boho: Costero",
      tagline: "Kaftanes, rafia y calma de la orilla",
      metaDescription:
        "Kaftanes, rafia, conchas y aire resort: estilo boho costero.",
    },
    "boho-festival": {
      title: "Boho: Festival",
      tagline: "Lentejuelas, metálicos y flecos protagonistas",
      metaDescription:
        "Lentejuelas, metálicos y flecos llamativos: boho listo para festivales.",
    },
    "boho-earthy": {
      title: "Boho: Terroso",
      tagline: "Terracota, arcilla y texturas artesanales",
      metaDescription:
        "Terracota, arcilla y texturas artesanales crudas: boho terroso y arraigado.",
    },
    "boho-modern": {
      title: "Boho: Moderno",
      tagline: "Minimalismo estructurado y lujo silencioso",
      metaDescription:
        "Minimalista, estructurado y monocromo: boho de lujo silencioso.",
    },
  },
};
